import React from 'react'
import * as yup from 'yup'

import { FormattedMessage } from '@divvy-web/i18n'

export const codeVerificationFormValidationSchema = yup.object().shape({
  code: yup
    .string()
    .required(() => (
      <FormattedMessage
        defaultMessage='Code is required to continue'
        id='sputnik.codeVerificationFormValidationSchema__42L5uh'
      />
    ))
    .test(
      'isInteger',
      () => (
        <FormattedMessage
          defaultMessage='Code must be an integer'
          id='sputnik.codeVerificationFormValidationSchema__9as/3I'
        />
      ),
      (value) => {
        if (!value) {
          return true
        }

        try {
          const parsed = parseFloat(value)
          return Number.isFinite(parsed) && !Number.isNaN(parsed) && Number.isInteger(parsed)
        } catch {
          return false
        }
      },
    )
    .length(5, () => (
      <FormattedMessage
        defaultMessage='Code must be 5 characters'
        id='sputnik.codeVerificationFormValidationSchema__9rMP+t'
      />
    )),
})

export type CodeVerificationFormValidationSchema = yup.InferType<typeof codeVerificationFormValidationSchema>
